import React from "react";
import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import printheaderImage from "./images/IDC-HEADER.png";
import printfooterImage from "./images/IDC-FOOTER.png";
import printcontentImage from "./images/IDC-CONTENT.png"; // Add your background image

const MyDocument = ({
  patientDataTitle,
  patientDataDateOfBirth,
  patientDataGender,
  patientDataPatientID,
  referededBy,
  reportUUID,
  requestDataCreated,
  reportDataCreated,
  investigationsDataTitle,
  requestDataFieldClinicalDiagnosis,
  requestDataFieldComments,
  reportDataTitle,
  reportDataFieldReportTechnique = "",
  reportDataFieldReportFindings,
  reportDataFieldReportImpression,
  reporterDataFieldDoctorRefererfullname,
  reporterDataFieldSpecialty,
  noreportMessage,
  signatureimageSRC,
}) => {
  return (
    <Document
      author={`${reporterDataFieldDoctorRefererfullname}`}
      subject={`${reportDataTitle}`}
    >
      <Page style={styles.page} size={"A4"} orientation="portrait">
        <View style={styles.container}>
          {/* Background Image */}
          <View style={styles.backgroundImage}>
            <Image src={printcontentImage} style={styles.imageIMG} />
          </View>

          {/* Header */}
          <View style={styles.header}>
            <Image src={printheaderImage} style={styles.headerImage} />
          </View>

          {/* Patient Information */}
          <View style={styles.section}>
            <View style={styles.infoBlock1}>
              <View style={styles.text}>
                <Text style={styles.normalText}>Full Name: </Text>
                <Text style={styles.boldText}>{patientDataTitle}</Text>
              </View>

              <View style={styles.text}>
                <Text style={styles.boldText}>Patient ID: </Text>
                <Text style={styles.normalText}>{patientDataPatientID}</Text>
              </View>
            </View>

            <View style={styles.infoBlock2}>
              <View style={styles.text}>
                <Text style={styles.boldText}>Age: </Text>
                <Text style={styles.normalText}>{patientDataDateOfBirth}</Text>
              </View>

              <View style={styles.text}>
                <Text style={styles.boldText}>Gender: </Text>
                <Text style={styles.normalText}>{patientDataGender}</Text>
              </View>

              <View style={styles.text}>
                <Text style={styles.boldText}>Requested By: </Text>
                <Text style={styles.normalText}>{referededBy}</Text>
              </View>
            </View>

            <View style={styles.infoBlock3}>
              <View style={styles.text}>
                <Text style={styles.boldText}>Report ID: </Text>
                <Text style={styles.normalText}>{reportUUID}</Text>
              </View>
              <View style={styles.text}>
                <Text style={styles.boldText}>Request Date: </Text>
                <Text style={styles.normalText}>{requestDataCreated}</Text>
              </View>
              <View style={styles.text}>
                <Text style={styles.boldText}>Reported Date: </Text>
                <Text style={styles.normalText}>{reportDataCreated}</Text>
              </View>
            </View>
          </View>

          {/* Clinical History */}
          <View style={styles.requestsection}>
            <Text style={styles.requestboldText}>Investigation:</Text>
            <Text style={styles.requestnormalText}>
              {investigationsDataTitle}
            </Text>
            <Text style={styles.requestboldText}>Clinical Diagnosis:</Text>
            <Text style={styles.requestnormalText}>
              {requestDataFieldClinicalDiagnosis}
            </Text>
          </View>

          {/* Report Details */}
          {reportDataFieldReportTechnique.length > 0 ? (
            <View style={{ flexGrow: 1 }}>
              <Text style={styles.reporttitle}>{reportDataTitle}</Text>

              <View style={styles.reportblocks}>
                <Text style={styles.reporttextbold}>Technique:</Text>
                <Text style={styles.reporttextnormal}>
                  {reportDataFieldReportTechnique}
                </Text>
              </View>

              <View style={styles.reportblocks}>
                <Text style={styles.reporttextbold}>Findings:</Text>
                <Text style={styles.reporttextnormal}>
                  {reportDataFieldReportFindings}
                </Text>
              </View>

              <View style={styles.reportblocks}>
                <Text style={styles.reporttextbold}>Impression:</Text>
                <Text style={styles.reporttextnormal}>
                  {reportDataFieldReportImpression}
                </Text>
              </View>

              <View style={styles.signatureBlock}>
                <View style={styles.signature}>
                  <Image
                    src={signatureimageSRC}
                    style={styles.signatureimage}
                  />
                  <Text
                    style={styles.signatureimageLine}
                  >{`................................`}</Text>
                </View>
                <View style={styles.text}>
                  <Text style={styles.reportfootertextbold}>
                    {reporterDataFieldDoctorRefererfullname}
                  </Text>
                </View>
                <View style={styles.reportfootertextnormal}>
                  <Text>{reporterDataFieldSpecialty}</Text>
                </View>
              </View>
            </View>
          ) : (
            <View>
              <Text style={styles.text}>{noreportMessage}</Text>
            </View>
          )}

          {/* Footer */}
          <View style={styles.footer}>
            <Image src={printfooterImage} style={styles.footerImage} />
          </View>
        </View>
      </Page>
    </Document>
  );
};

// Define styles for the PDF
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontFamily: "Helvetica",
    position: "relative",
    flexDirection: "column",
    flexGrow: 1,
    justifyContent: "space-between",
    height: "100%",
  },
  header: {
    width: "100%",
    marginBottom: 12,
  },
  headerImage: {
    width: "46%",
    alignSelf: "center",
  },
  content: {
    flexGrow: 1,
  },
  signatureBlock: {
    position: "absolute",
    bottom: 74,
    left: 0,
    right: 0,
  },
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    textAlign: "center",
    zIndex: -1,
  },
  footerImage: {
    width: "90%",
    alignSelf: "center",
  },
  section: {
    marginBottom: 24,
  },
  reporttitle: {
    fontSize: 13,
    textAlign: "center",
    fontFamily: "Helvetica-Bold",
    textDecoration: "underline",
  },
  subtitle: {
    fontSize: 11,
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
    marginBottom: 5,
  },
  text: {
    flexDirection: "row",
    marginBottom: 5,
  },
  boldText: {
    fontSize: 11,
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
  },
  normalText: {
    fontSize: 11,
    fontWeight: "normal",
  },
  requestboldText: {
    fontSize: 11,
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
    marginBottom: 4,
  },
  requestnormalText: {
    fontSize: 11,
    fontWeight: "normal",
    marginBottom: 12,
  },
  reportblocks: {
    width: "100%",
    marginBottom: 16,
  },
  reporttextbold: {
    fontSize: 11,
    fontFamily: "Helvetica-Bold",
    marginBottom: 6,
  },
  reporttextnormal: {
    fontSize: 11,
    lineHeight: 1.5,
    marginBottom: 6,
  },
  reportfootertextbold: {
    fontSize: 11,
    fontFamily: "Helvetica-Bold",
    marginBottom: 4,
  },
  reportfootertextnormal: {
    fontSize: 11,
  },
  infoBlock1: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderTopColor: "#000000",
    borderTopWidth: 1,
    borderBottomColor: "#000000",
    borderBottomWidth: 1,
    paddingVertical: 4,
    backgroundColor: "#FAFAFA",
  },
  infoBlock2: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomColor: "#000000",
    borderBottomWidth: 1,
    paddingVertical: 4,
    backgroundColor: "#FAFAFA",
  },
  infoBlock3: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomColor: "#000000",
    borderBottomWidth: 1,
    paddingVertical: 4,
    backgroundColor: "#FAFAFA",
  },
  requestsection: {
    width: "100%",
    overflow: "hidden",
    marginBottom: 24,
  },
  container: {
    position: "relative",
    width: "100%",
    height: "100%",
  },
  backgroundImage: {
    position: "absolute",
    top: "26%",
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: -1, // Place the image behind the content
  },
  imageIMG: {
    position: "relative",
    left: 70,
    right: 0,
    width: "77%",
    height: "54%",
    resizeMode: "cover",
  },
  signatureimage: {
    width: 128,
    height: 32,
    resizeMode: "cover",
  },
  signatureimageLine: {
    fontSize: 12,
    fontWeight: "normal",
    fontFamily: "Helvetica",
    marginBottom: 12,
  },
});

export default MyDocument;
